







































import { Component, Vue } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';

@Component
export default class WaitingListsEmbed extends Vue {
    constructor() {
        super();
    }

    get oauthClientData() {
        return this.$store.getters['WaitingLists/getOauthClientData'];
    }

    get getEnEmbedDiv() {
        const data = this.oauthClientData;
        if (data) {
            return `<div id="waiting-list" data-lang="en" data-client_id="${data.client_id}" data-client_secret="${data.client_secret}"></div>`;
        }
    }

    get getDaEmbedDiv() {
        const data = this.oauthClientData;
        if (data) {
            return `<div id="waiting-list" data-lang="dk" data-client_id="${data.client_id}" data-client_secret="${data.client_secret}"></div>`;
        }
    }

    get getJsContent() {
        const data = this.oauthClientData;
        if (data) {
            return  data.js_content;
        }
    }

    public copyEmbedContent(lang: string) {
        const element = (this.$refs[lang] as HTMLInputElement);
        element.select();
        document.execCommand('copy');
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_OAUTH_CLIENT_DATA);
    }
}
